<template>
  <mds-page-shell
    :logo="require('@/assets/logos/morningstar.svg')"
    :logo-responsive="require('@/assets/logos/morningstar.svg')"
    logo-href="/"
    
  >
    <template #mds-page-shell-masthead-left>
        <img
          src="@/assets/logos/morningstar.svg"
          alt="Morningstar Logo"
          style="cursor: pointer;"
        />
      </template>
    
    <template #mds-page-shell-masthead-right>
      <div class="rigth-content">
        <env-tag />
      </div>
    </template>
    <template #default>
      <mds-layout-grid>
        <sign-in-form />
      </mds-layout-grid>
    </template>
  </mds-page-shell>
</template>

<script>
import MdsPageShell from '@mds/page-shell';
import SignInForm from '@/components/sign-in/form/SignInForm';
import EnvTag from '@/components/ui/EnvironmentTag.vue';

export default {
  name: 'SignInPage',
  components: {
    MdsPageShell,
    SignInForm,
    EnvTag,
  },
  methods: {
    goHome() {
      if (this.$route.path !== '/') {
        this.$router.push({ path: '/' }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    },
  }
};
</script>

<style lang="scss" scoped>
.rigth-content {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: flex-start;
}
</style>
